import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import Footer from './Footer';
import envConfig from '../envConfig';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx'; // Import xlsx for Excel generation
import { formatToHumanDateTime } from '../utils/DateFormatter';

function RecipientsModal({ row, onClose }) {
    const fmtDate = d => {
        if (!d) return '--';
        const dt = new Date(d);
        return `${dt.toLocaleString('default', { month: 'short' })} ${dt.getDate()}, ${dt.getFullYear()}`;
    };
    return (
        <>
            <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 9998, background: 'rgba(0,0,0,0.4)' }} />
            <div style={{
                position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
                zIndex: 9999, background: '#fff', borderRadius: '6px', width: '580px', maxWidth: '95vw',
                boxShadow: '0 4px 20px rgba(0,0,0,0.25)', overflow: 'hidden',
            }}>
                <div style={{ background: '#2e7d32', color: '#fff', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '15px' }}>Recipients — {row.adm3}</div>
                        <div style={{ fontSize: '12px', opacity: 0.85, marginTop: '3px' }}>{row.adm1} &rsaquo; {row.adm2} &rsaquo; {row.adm3}</div>
                    </div>
                    <span onClick={onClose} style={{ cursor: 'pointer', fontSize: '20px', lineHeight: 1, marginLeft: '12px' }}>&times;</span>
                </div>
                <div style={{ padding: '8px 16px', fontSize: '12px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6', display: 'flex', gap: '20px' }}>
                    {row.weekly
                        ? <span>Week: <strong>{fmtDate(row.week_start)}</strong> – <strong>{fmtDate(row.week_end)}</strong></span>
                        : <span>Date: <strong>{fmtDate(row.ref_date)}</strong></span>
                    }
                    <span>Count: <strong>{row.recepient_count}</strong></span>
                </div>
                <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead style={{ position: 'sticky', top: 0, background: '#f1f1f1' }}>
                            <tr>
                                <th style={{ padding: '6px 12px', textAlign: 'left', fontWeight: 600, width: '32px' }}>#</th>
                                <th style={{ padding: '6px 12px', textAlign: 'left', fontWeight: 600 }}>Name</th>
                                <th style={{ padding: '6px 12px', textAlign: 'left', fontWeight: 600 }}>Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(row.recipients || []).map((r, i) => (
                                <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                                    <td style={{ padding: '4px 10px', color: '#aaa', whiteSpace: 'nowrap' }}>{i + 1}</td>
                                    <td style={{ padding: '4px 10px', whiteSpace: 'nowrap' }}>{r[0]}</td>
                                    <td style={{ padding: '4px 10px', color: '#555', whiteSpace: 'nowrap' }}>{r[1]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{ padding: '10px 16px', textAlign: 'right', borderTop: '1px solid #dee2e6' }}>
                    <button onClick={onClose} style={{ padding: '5px 18px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}>Close</button>
                </div>
            </div>
        </>
    );
}

function RecipientsCell({ row }) {
    const [open, setOpen] = useState(false);
    const count = row.recepient_count;
    if (!count || count === 0) return <span>NA</span>;
    return (
        <span>
            <span>{count}</span>
            {row.recipients && row.recipients.length > 0 && (
                <>
                    <span
                        onClick={() => setOpen(true)}
                        style={{ cursor: 'pointer', marginLeft: '5px', color: '#1565c0', fontWeight: 'bold', fontSize: '13px' }}
                        title="View recipients"
                    >&#9432;</span>
                    {open && <RecipientsModal row={row} onClose={() => setOpen(false)} />}
                </>
            )}
        </span>
    );
}

function MessageLogs(props) {
    const { isAuthenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [countries, setCountries] = useState(null);
    const [provinces, setProvinces] = useState(null);
    const [districts, setDistricts] = useState(null);
    const [villages, setVillages] = useState(null);
    const [filteredProvinces, setFilteredProvinces] = useState(null);
    const [filteredDistricts, setFilteredDistricts] = useState(null);
    const [filteredVillages, setFilteredVillages] = useState(null);
    const [fisherMen, setFisherMen] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedVillage, setSelectedVillage] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [formError, setFormError] = useState(null);
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [totalRows, setTotalRows] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const [activeTab, setActiveTab] = useState(null);
    const [selectedType, setSelectedType] = useState('');


    useEffect(() => {
        if (!isAuthenticated) {
            window.location.href = '/login';
        }
    }, [isAuthenticated, navigate]);

    const getAuthHeaders = () => {
        const token = localStorage.getItem('profishBlue_authToken');
        const expiryTime = localStorage.getItem('profishBlue_tokenExpiry');

        const isTokenExpired = !token || !expiryTime || Date.now() > parseInt(expiryTime, 10);

        if (isTokenExpired) {
            logout();
            window.location.href = '/login';
            return {};
        }

        return {
            'Content-Type': 'application/json',
            Authorization: token,
        };
    };

    const handleApiError = (error, response) => {
        if (
            response &&
            response.status === 401 &&
            error.message.includes('Your authentication token is invalid')
        ) {
            setTimeout(() => {
                logout();
                window.location.href = '/login';
            }, 0);
            return 'Session expired. Please log in again.';
        }
        return error.message || 'An error occurred. Please try again.';
    };

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch(`${envConfig.API_URL}/lookups/locations/country`, {
                    headers: getAuthHeaders(),
                });
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setCountries(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };

        if (isAuthenticated) {
            fetchCountries();
        }
    }, [isAuthenticated]);

    useEffect(() => {
        const fetchProvinces = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm1?country_id=${selectedCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setProvinces(data.data || []);
                setFilteredProvinces(data.data || []);
                setSelectedProvince(null);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };

        const fetchDistricts = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm2?country_id=${selectedCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setDistricts(data.data || []);
                setFilteredDistricts(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };

        const fetchVillages = async () => {
            try {
                const response = await fetch(
                    `${envConfig.API_URL}/lookups/locations/adm3?country_id=${selectedCountry}`,
                    {
                        headers: getAuthHeaders(),
                    }
                );
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setVillages(data.data || []);
                setFilteredVillages(data.data || []);
            } catch (error) {
                setFormError(handleApiError(error, error.response));
            }
        };

        if (selectedCountry && isAuthenticated) {
            fetchProvinces();
            fetchDistricts();
            fetchVillages();
        }
    }, [selectedCountry, isAuthenticated]);

    useEffect(() => {
        if (districts && selectedProvince) {
            setFilteredDistricts(
                districts.filter((district) => district.adm1_id === parseInt(selectedProvince))
            );
            setSelectedDistrict(null);
        } else {
            setFilteredDistricts(null);
            setSelectedDistrict(null);
            setFilteredVillages(null);
            setSelectedVillage(null);
        }
    }, [selectedProvince, districts]);

    useEffect(() => {
        if (villages && selectedDistrict) {
            setFilteredVillages(
                villages.filter((village) => village.adm2_id === parseInt(selectedDistrict))
            );
            setSelectedVillage(null);
        } else {
            setFilteredVillages(null);
        }
    }, [selectedDistrict, villages]);

    const fetchMessageLogs = async (forExport = false, typeOverride = undefined) => {
        if (!selectedCountry) return;

        setIsLoading(true);
        setFetchError(null);
        if (!activeTab) {
            setActiveTab('active');
        }
        const effectiveType = typeOverride !== undefined ? typeOverride : selectedType;
        try {
            let url = `${envConfig.API_URL}/advisory/message_log`;
            const params = new URLSearchParams({ country_id: selectedCountry });

            // Only append parameters if they have valid values
            if (selectedProvince) params.append('adm1_id', selectedProvince);
            if (selectedDistrict) params.append('adm2_id', selectedDistrict);
            if (selectedVillage) params.append('adm3_id', selectedVillage);
            if (selectedStartDate) params.append('start_date', selectedStartDate);
            if (selectedEndDate) params.append('end_date', selectedEndDate);
            if (effectiveType) params.append('type', effectiveType);

            if (!forExport) {
                params.append('page', pageNo);
                params.append('size', perPage);
            } else {
                params.append('size', '10000'); // Fetch all data for export
            }

            url += `?${params.toString()}`;

            const response = await fetch(url, {
                headers: getAuthHeaders(),
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();
            if (data.success === 1) {
                if (forExport) {
                    return data.data || [];
                }
                setFisherMen(data.data || []);
                const newTotalRows = data.metadata?.total_count || data.data.length;
                setTotalRows(newTotalRows);
            } else {
                throw new Error('API request failed');
            }
        } catch (error) {
            setFetchError(handleApiError(error, error.response));
            setFisherMen([]);
            setTotalRows(0);
            return [];
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if (!selectedCountry) {
            setFormError('Country selection is mandatory.');
            return;
        }
        setFormError(null);
        setPageNo(1);
        fetchMessageLogs();
    };

    const onCountryChange = (e) => {
        setSelectedCountry(e.target.value);
        setProvinces(null);
        setDistricts(null);
        setVillages(null);
        setFilteredProvinces(null);
        setFilteredDistricts(null);
        setFilteredVillages(null);
        setSelectedProvince(null);
        setSelectedDistrict(null);
        setSelectedVillage(null);
        // setPageNo(1);
        // setPerPage(5);
        // setSelectedRows([]);
        // setFisherMen([]);
        // setTotalRows(0);
    };

    const handleExportData = async () => {
        if (!selectedCountry) {
            Swal.fire({
                title: 'Country Required',
                text: 'Please select a country before exporting data.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Preparing Export...',
                text: 'Fetching data for export. Please wait...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            const allFishermen = await fetchMessageLogs(true);

            if (!allFishermen || !allFishermen.length) {
                Swal.fire({
                    title: 'No Data',
                    text: 'No Message Logs available to export.',
                    icon: 'info',
                    confirmButtonText: 'OK',
                });
                return;
            }           

            const campOrEpaLabel = selectedCountry == 1 ? 'EPA' : 'Camp';

            const exportData = allFishermen.map((row, index) => ({
                SNo: index + 1,
                'Type': row.weekly && row.week_start ? `Weekly (${fmtShort(row.week_start)} – ${fmtShort(row.week_end)})` : 'Daily',
                'Referred Date': formatToHumanDateTime(row.ref_date) || '--',
                'Sent Date': row.sent_on ? formatToHumanDateTime(row.sent_on) : '--',
                Country: row.country || '--',
                Province: row.adm1 || 'Province Name',
                District: row.adm2 || 'District Name',
                [campOrEpaLabel]: row.adm3 || (selectedCountry == 1 ? 'EPA Name' : 'Camp Name'),
                Message: row.advisory_text?.replace(/\n/g, ' ') || '--',
                'Risk Level': row.risk_level ?? '--',
                'Pond Temperature (°C)': row.weekly
                    ? (row.week_pond_temp_min != null ? `${row.week_pond_temp_min}–${row.week_pond_temp_max}°C` : '--')
                    : (row.predicted_pond_temperature != null ? `${row.predicted_pond_temperature}°C` : '--'),
                'Max Air Temp (°C)': row.temp_max !== undefined && row.temp_max !== null ? `${row.temp_max}°C` : '--',
                'Min Air Temp (°C)': row.temp_min !== undefined && row.temp_min !== null ? `${row.temp_min}°C` : '--',
                'Recipient Count': row.recepient_count ?? 'NA',
                'SMS Status': row.pushed_status ?? '--',
                'SMS Fail Reason': row.pushed_status_reason ?? '--',
            }));

            const worksheet = XLSX.utils.json_to_sheet(exportData);

            worksheet['!cols'] = Object.keys(exportData[0]).map((key) => ({
                wch: Math.max(15, key.length + 5),
            }));

            // Optional: basic header styling (Excel won't render style unless opened in some programs)
            // Note: true styling needs xlsx-style library, not vanilla xlsx

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Message Logs Export');

            const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            const filename = `Messagelog_Country_${selectedCountry}_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);

            Swal.fire({
                title: 'Export Successful!',
                text: `Data has been exported as ${filename}.`,
                icon: 'success',
                confirmButtonText: 'OK',
            });
        } catch (error) {
            Swal.fire({
                title: 'Export Failed',
                text: error.message || 'An unexpected error occurred while exporting data.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    const fmtShort = d => { const dt = new Date(d); return `${dt.toLocaleString('default', { month: 'short' })} ${dt.getDate()}`; };

    const columns = [
        {
            name: 'Type',
            selector: (row) => row.weekly ? 'Weekly' : 'Daily',
            cell: (row) => {
                const autoBadge = row.cron_auto
                    ? <><br /><small style={{ padding: '1px 5px', borderRadius: '3px', fontSize: '9px', background: '#1565c0', color: '#fff' }}>Auto</small></>
                    : null;
                return row.weekly && row.week_start
                    ? <span title={`${fmtShort(row.week_start)} – ${fmtShort(row.week_end)}`}>Weekly<br /><small className="text-muted">{fmtShort(row.week_start)} – {fmtShort(row.week_end)}</small>{autoBadge}</span>
                    : <span>Daily{autoBadge}</span>;
            },
            sortable: true,
            width: '130px',
        },
        {
            name: 'Ref. Date',
            selector: (row) => formatToHumanDateTime(row.ref_date) || '--',
            sortable: true,
            width: '110px',
            cell: (row) => <span style={{ whiteSpace: 'normal', overflow: 'visible' }}>{formatToHumanDateTime(row.ref_date) || '--'}</span>,
        },
        {
            name: 'Sent On',
            selector: (row) => formatToHumanDateTime(row.sent_on) || '--',
            sortable: true,
            width: '150px',
            cell: (row) => <span style={{ whiteSpace: 'normal', overflow: 'visible' }}>{formatToHumanDateTime(row.sent_on) || '--'}</span>,
        },
        {
            name: 'Country',
            selector: (row) => row.country || '--',
            sortable: true,
            width: '90px',
        },
        {
            name: 'Province',
            selector: (row) => row.adm1 || '--',
            sortable: true,
            width: '100px',
        },
        {
            name: 'District',
            selector: (row) => row.adm2 || '--',
            sortable: true,
            width: '100px',
        },
        {
            name: selectedCountry === 1 ? 'EPA' : 'Camp',
            selector: (row) => row.adm3 || '--',
            sortable: true,
            width: '100px',
        },
        {
            name: 'Message',
            selector: (row) => row.advisory_text || '--',
            sortable: true,
            grow: 2,
            cell: (row) => (
                <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px', lineHeight: '1.3' }}>
                    {row.advisory_text || '--'}
                </div>
            ),
        },
        {
            name: 'Risk Level',
            selector: (row) => row.risk_level ?? '--',
            sortable: true,
            width: '130px',
        },
        {
            name: 'Pond Temp',
            selector: (row) => row.weekly
                ? (row.week_pond_temp_min != null ? `${row.week_pond_temp_min}–${row.week_pond_temp_max}°C` : '--')
                : (row.predicted_pond_temperature != null ? `${row.predicted_pond_temperature}°C` : '--'),
            sortable: true,
            width: '120px',
        },
        {
            name: 'Max Temp',
            selector: (row) => `${row.temp_max ?? '--'}°C`,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Min Temp',
            selector: (row) => `${row.temp_min ?? '--'}°C`,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Recipients',
            selector: (row) => row.recepient_count ?? 'NA',
            sortable: true,
            width: '110px',
            cell: (row) => <RecipientsCell row={row} />,
        },
        {
            name: 'SMS Status',
            selector: (row) => row.pushed_status ?? '--',
            sortable: true,
            width: '110px',
            cell: (row) => {
                if (row.pushed_status === 'sent') return <span style={{ padding: '2px 6px', borderRadius: '3px', background: '#2e7d32', color: '#fff', fontSize: '11px' }}>Sent</span>;
                if (row.pushed_status === 'failed') return <span title={row.pushed_status_reason || ''} style={{ padding: '2px 6px', borderRadius: '3px', background: '#c62828', color: '#fff', fontSize: '11px', cursor: 'help' }}>Failed</span>;
                return <span style={{ color: '#999', fontSize: '11px' }}>--</span>;
            },
        },
    ];

    const handlePageChange = (page) => {
        setPageNo(page);
        setSelectedRows([]);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setPageNo(page);
        setSelectedRows([]);
    };

    useEffect(() => {
        if (selectedCountry && pageNo && perPage) {
            fetchMessageLogs();
        }
    }, [pageNo, perPage, activeTab]);

    const handleTypeChange = (type) => {
        setSelectedType(type);
        setPageNo(1);
        if (activeTab) fetchMessageLogs(false, type);
    };

    const handleRowSelected = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    const customStyles = {
        table: {
            style: {
                border: '1px solid #dee2e6',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#2e7d32',
                color: '#ffffff',
                fontWeight: 'bold',
                borderBottom: '1px solid #dee2e6',
            },
        },
        headCells: {
            style: {
                padding: '10px 15px!important',
                borderRight: '1px solid #dee2e6',
            },
        },
        cells: {
            style: {
                padding: '5px 5px!important',
                borderRight: '1px solid #dee2e6',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        },
        rows: {
            style: {
                maxHeight: '80px',
                '&:hover': {
                    backgroundColor: '#f1f1f1',
                },
            },
        },
        pagination: {
            style: {
                padding: '4px 8px',
                minHeight: '40px',
                border: 'none',
                padding: '5px 5px 5px 5px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                backgroundColor: '#e8f5e9',
            },
            pageButtonsStyle: {
                backgroundColor: 'transparent',
                border: 'none',
                color: '#000',
                padding: '0.25rem 0.5rem',
                margin: '0 0.25rem',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#d4edda',
                },
                '&:disabled': {
                    opacity: 0.5,
                    cursor: 'not-allowed',
                },
            },
        },
    };

    return (
        <>
            <div className="wrapper pt-100px one">
                <div className="container-fluid">
                    <div className="row pt-3">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="box-config">
                                <h5>Message Logs</h5>
                                <form onSubmit={handleFilterSubmit} className="">
                                    <div className="row mb-3 align-items-end">
                                        <div className="col-sm-12 col-md-11 col-lg-11">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-2">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="country">Country <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedCountry || ''}
                                                            onChange={onCountryChange}
                                                        >
                                                            <option value="">Select</option>
                                                            {countries &&
                                                                countries.map((country) => (
                                                                    <option key={country.country_id} value={country.country_id}>
                                                                        {country.country || country.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-2">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="province">Province</label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedProvince || ''}
                                                            onChange={(e) => setSelectedProvince(e.target.value)}
                                                            disabled={!selectedCountry}
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredProvinces &&
                                                                filteredProvinces.map((province) => (
                                                                    <option key={province.adm1_id} value={province.adm1_id}>
                                                                        {province.adm1 || province.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-2">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="district">District</label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedDistrict || ''}
                                                            onChange={(e) => setSelectedDistrict(e.target.value)}
                                                            disabled={!selectedProvince}
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredDistricts &&
                                                                filteredDistricts.map((district) => (
                                                                    <option key={district.adm2_id} value={district.adm2_id}>
                                                                        {district.adm2 || district.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-2">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="village">{selectedCountry == 1 ? 'EPA' : 'Camp'}</label>
                                                        <select
                                                            className="form-select custom-select"
                                                            value={selectedVillage || ''}
                                                            onChange={(e) => setSelectedVillage(e.target.value)}
                                                            disabled={!selectedDistrict}
                                                        >
                                                            <option value="">Select</option>
                                                            {filteredVillages &&
                                                                filteredVillages.map((village) => (
                                                                    <option key={village.adm3_id} value={village.adm3_id}>
                                                                        {village.adm3 || village.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-2">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="startDate">Start Date <span className="text-danger"></span></label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={selectedStartDate}
                                                            onChange={(e) => setSelectedStartDate(e.target.value)}
                                                            max={new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} // Set max to 14 days from today
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-2">
                                                    <div className="form-group me-2">
                                                        <label htmlFor="endDate">End Date <span className="text-danger"></span></label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={selectedEndDate || ''}
                                                            onChange={(e) => setSelectedEndDate(e.target.value)}
                                                            max={new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} // Set max to 14 days from today
                                                            min={selectedStartDate}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-sm-12 col-md-1 col-lg-1">
                                            <button type="submit" className="btn btn-apply" style={{ height: '36px', width: '100%',marginTop:'-26px' }}>
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                {formError && <div className="text-danger mt-2">{formError}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg">
                            <div className="filter-box border p-2" style={{ borderRight: '0px', height: 'auto' }}>
                                <h5 className="text-capitalize">Message Logs</h5>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                        {selectedRows.length > 0 && (
                                            <p className="mb-0">{selectedRows.length} row(s) selected</p>
                                        )}
                                        {activeTab && (
                                            <div className="btn-group btn-group-sm" role="group">
                                                {[['', 'All'], ['daily', 'Daily'], ['weekly', 'Weekly']].map(([val, label]) => (
                                                    <button
                                                        key={val}
                                                        type="button"
                                                        className={`btn ${selectedType === val ? 'btn-success' : 'btn-outline-secondary'}`}
                                                        onClick={() => handleTypeChange(val)}
                                                    >
                                                        {label}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <button
                                                className="btn btn-new ms-2 pe-2"
                                                onClick={handleExportData}
                                                style={{ marginBottom: '23px' }}
                                                disabled={!selectedCountry}
                                                title="Export all data to Excel"
                                            >
                                                <span>
                                                    <img
                                                        src="./assets/images/download.svg"
                                                        alt=""
                                                        style={{ height: '21px' }}
                                                    />
                                                </span>
                                                Export Data
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <DataTable
                                    key={activeTab}
                                    columns={columns}
                                    data={fisherMen}
                                    // selectableRows
                                    // onSelectedRowsChange={handleRowSelected}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationDefaultPage={pageNo}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    paginationRowsPerPageOptions={[5, 10, 25, 50]}
                                    paginationPerPage={perPage}
                                    paginationComponentOptions={{
                                        rowsPerPageText: 'Records per page:',
                                        rangeSeparatorText: 'of',
                                        selectAllRowsItem: false,
                                    }}
                                    customStyles={customStyles}
                                    noDataComponent={<div className="text-center p-2 font-14px">No Message Logs found</div>}
                                    highlightOnHover
                                    dense
                                    keyField="id"
                                    progressPending={isLoading}
                                    progressComponent={<div className="text-center p-2 font-14px">Loading...</div>}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default MessageLogs;